import { Container } from "react-bootstrap";
import LoginForm from "../components/LoginForm";

export default function LoginPage() {
    return (
        <>
            <Container>
                <LoginForm />
            </Container>
        </>
    );
}
